import BaseApi from "./BaseApi";

export default class State extends BaseApi{
    construct() {}

    static async list(params) {
        let url = State.getApiUrl() + "list";

        return State.getAxiosInstance().get(url,{params: params});
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/client/categories/";
    }
}